import * as React from "react";
import {Badge} from "react-bootstrap";
import utils from "../../helpers/utils";
import {NewTabBadge} from "../../components/badge/NewTabBadge";
import Tooltip from "../../components/tooltip/Tooltip";
import { useTranslation } from 'react-i18next';

function calculateAvailablePartsCount(option, simulation, lineMachinesIds) {
    return option.formatParts
        ?.filter(part =>
            part.formatPart.machineIds.some(machineId => lineMachinesIds.includes(machineId))
        )
        .filter(part => simulation ? part.partStatus !== "WITHDRAWN" : part.partStatus === "STORAGE").length;
}


export const fields = (simulation, lineMachinesIds, t) => {
    return {
        config: {columns: 1},
        fields: [
            {
                name: "format",
                label: t ? t("forms.install_all_from_format") : "Urządź wszystko z formatu",
                column: 1,
                type: "dictionary",
                useSelect: true,
                dictionary: "format",
                placeholder: t ? t("forms.choose_format") : "Wybierz format",
                searchBy: function (option) {
                    return utils.join([option.id, calculateAvailablePartsCount(option, simulation, lineMachinesIds)])
                },
                optionDisabled: function (option) {
                    return calculateAvailablePartsCount(option, simulation, lineMachinesIds) === 0
                },
                mandatory: false,
                renderOption: (option) => <>
                    <Badge className={"outline-secondary font-max mr-1"}>ID</Badge>
                    <NewTabBadge tooltip={t ? t("production.more_about_format") : "Więcej o formacie"}
                                 placement={"right"}
                                 newTabUrl={"#/management/" + option.id}
                                 className={"mr-1"}>{option.id}</NewTabBadge>

                    {option.nameAndDose &&
                        <Badge className={"outline-secondary font-max mr-1"}>{option.nameAndDose}</Badge>}
                    {option.packingLine &&
                        <Badge className={"outline-secondary font-max mr-1"}>{option.packingLine.name}</Badge>}
                    <Tooltip tooltip={t ? t("production.available_parts") : "Dostępne części"} placement={"right"}>
                        <Badge variant={"primary"}
                               className={""}>{calculateAvailablePartsCount(option, simulation, lineMachinesIds)}</Badge>
                    </Tooltip>
                </>,
            },
        ]
    }
};
